import React from "react";

type Props = {
  status?: string;
  className?: string;
  preText?: string;
};

type StatusKey =
  | "in progress"
  | "pending"
  | "completed"
  | "overdue"
  | "gov sign off";

const WARNING = "bg-warning-subtle text-warning";

const statusClass: Record<StatusKey, string> = {
  "in progress": "bg-primary-subtle text-primary",
  pending: WARNING,
  completed: "bg-success-subtle text-success",
  overdue: "bg-danger-subtle text-danger",
  "gov sign off": "bg-info-subtle text-info",
};

const normalizeStatus = (status?: string): StatusKey | undefined => {
  if (!status) return undefined;
  
  const normalized = status.trim().toLowerCase().replace(/[-_]/g, " ");
  
  if (normalized in statusClass) {
    return normalized as StatusKey;
  }
  
  return undefined;
};

const EvalStatus: React.FC<Props> = ({
  status = "",
  className = "",
  preText = "",
}) => {
  const normalized = normalizeStatus(status);
  const badgeType =
    (normalized && statusClass[normalized]) ||
    "bg-secondary-subtle text-secondary";

  return (
    <span className={`badge ${badgeType} ${className}`}>
      {preText}
      {status}
    </span>
  );
};

export default EvalStatus;